import { compose } from 'recompose';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';

import {
  selectCurrentMetricHeightType,
  selectCurrentMetricWeightType,
  selectCurrentMetricGlucoseType,
  selectCurrentMetricTemperatureType,
} from '../../../redux/profiles/patientHealthboard/selectors';
import {
  loggedUserSelector,
  targetUserIdSelector,
  targetUserSelector,
} from '../../../redux/context/selectors';
import { currentHealthboardOptionsActions } from '../../../redux/profiles/patientHealthboard/currentHealthboardOptions';
import { actions as editUserActions } from '../../../redux/profiles/edit-user';

const mapStateToProps = state => ({
  currentMetricHeightType: selectCurrentMetricHeightType(state),
  currentMetricWeightType: selectCurrentMetricWeightType(state),
  currentMetricGlucoseType: selectCurrentMetricGlucoseType(state),
  currentMetricTemperatureType: selectCurrentMetricTemperatureType(state),
  profile: loggedUserSelector(state),
  profileTargetUser: targetUserSelector(state),
  userId: targetUserIdSelector(state),
});

const mapDispatchToProps = {
  editUser: editUserActions.send,
  setCurrentMetric: currentHealthboardOptionsActions.setCurrentMetric,
};
export const enhance = compose(
  injectIntl,
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
);



// WEBPACK FOOTER //
// ./src/components/ProfileLayout/UnitsSettings/enhance.js